import { render, staticRenderFns } from "./salesDataAnalysis.vue?vue&type=template&id=605d7a1f&scoped=true"
import script from "./salesDataAnalysis.vue?vue&type=script&lang=js"
export * from "./salesDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./salesDataAnalysis.vue?vue&type=style&index=0&id=605d7a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d7a1f",
  null
  
)

export default component.exports